import type { NavLink, SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'
import { PAINTINGS } from '@/constants/paintings'

export const siteConfig: SiteConfig = {
    name: 'Rembrandt van Rijn',
    description: 'Explore the life, masterpieces and painting techniques of Rembrandt van Rijn, the Dutch Golden Age master of light and shadow.',
    url: getOrigin(),
    ogImage: PAINTINGS.philemonAndBaucis.src
}

export const NAV_LINKS: NavLink[] = [
    { href: '/', label: 'Home' },
    { href: '/gallery', label: 'Gallery' },
    { href: '/biography', label: 'Biography' },
    { href: '/technique', label: 'Technique' }
]

export const MUSEUM_LINKS: NavLink[] = [
    { href: 'https://www.rijksmuseum.nl/en', label: 'Rijksmuseum' },
    { href: 'https://www.louvre.fr/en', label: 'The Louvre' },
    { href: 'https://www.nationalgallery.org.uk', label: 'The National Gallery' }
]

export const FOOTER_QUOTE = {
    text: 'Choose only one master, nature.',
    author: 'Rembrandt'
}
